import { fetchCurrentUserData } from "@/util/customFetch";
import { BACKEND_API_PLACEHOLDER } from '@/../environment.config'

export async function getActiveAnnouncements(siteId) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/announcements/active?site_id=${siteId}`
  return fetch(url, {
    method: 'GET',
    headers: tokenData,
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getAllAnnouncements() {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/announcements/`
  return fetch(url, {
    method: 'GET',
    headers: tokenData,
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

export async function createAnnouncement(body) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/announcements/`
  return fetch(url, {
    method: 'POST',
    headers: { ...tokenData, 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

export async function updateAnnouncement(id, body) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/announcements/${id}`
  return fetch(url, {
    method: 'PUT',
    headers: { ...tokenData, 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

export async function deleteAnnouncement(id) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/announcements/${id}`
  return fetch(url, {
    method: 'DELETE',
    headers: tokenData,
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

export async function dismissAnnouncementApi(userId, announcementId) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/announcements/dismiss`
  return fetch(url, {
    method: 'POST',
    headers: { ...tokenData, 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, announcement_id: announcementId })
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getDismissCounts() {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/announcements/dismiss/counts`
  return fetch(url, {
    method: 'GET',
    headers: tokenData,
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}
